export default {
  BusinessPurchaseApplyDetail: {
    status: 'Requisition Status',
    operationLog: 'Operation Log',
    number: 'Requested Quantity',
    already: 'Purchased Quantity',
    purchasedNot: 'Purchase not made',
    title: 'Requisition Account Information',
    code: 'Purchase Requisition Number',
    remark: 'Remarks',
    warehouseCode: 'Requested Receiving Warehouse',
    reviewTime: 'Review time',
    arrivalTime: 'Requested Arrival Time',
    productInformation: 'Apply for product information',
    firstReview: 'First Revie',
    secondReview: 'Second Review',
    thirdReview: 'Third Review',
    reviewRemark1: 'First Review Comment',
    reviewRemark2: 'Second Review Comment',
    reviewRemark3: 'Third Review Comment',
    orderQty: 'Ordered Quantity',
    reviewResult: 'Review Conclusion：',
    reviewResult1: 'Review Failed',
    reviewResult2: 'Review Passed',
    reviewRemark: 'Review Comment:',
    wordLimitText: 'Within 2500 words',
    errorMsg1: 'The audit conclusion cannot be empty.',

    table: {
      picture: 'Product Image',
      supplierCode: 'Request Supplier',
      spuCode: 'Product Code',
      spuName: 'Product Name',
      skuCode: 'SKU',
      skuName: 'SKU Name',
      planQty: 'Requested Quantity',
      alreadyQty: 'Ordered Quantity',
      associate: 'Associated Documents',
      associateType: 'Associated Document Type',
      associatedCode: 'Ref. No.',
      associatedStatusMeaning: 'Document Status',
    },
    dialogText1: 'Purchase Requisition',
    dialogText2: 'Log',
  }
};
